import React from 'react';
import HttpService from '../services/HttpService';

const statusToActiveStepMapper = (status: number) => status == null
  ? -1
  : status - 1; // check RequestStatus enum


export const useQueueState = (applicationId: number | string | undefined) => {

  const [activeQueueStep, setActiveQueueStep] = React.useState(-1);
  const [stepFailed, setStepFailed] = React.useState(-1);
  const [isLoading, setIsLoading] = React.useState(true);

  const fetchData = async () => {
    try {
      const resp = await HttpService.getAxiosClient().get(`/queue-state/${applicationId}`);
      resp.data.status === 4 && setStepFailed(statusToActiveStepMapper(resp.data.failed_step));
      setIsLoading(false);
      setActiveQueueStep(
        resp.data.status === 4
          ? statusToActiveStepMapper(resp.data.failed_step) :
          statusToActiveStepMapper(resp.data.status)
      );
    } catch (error) {
      setActiveQueueStep(-1);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);


  return {
    activeQueueStep,
    stepFailed,
    isLoading
  };

};
